const XSRF_COOKIE_NAME = 'XSRF-TOKEN';
const META_SELECTOR = 'meta[name="csrf-token"]';

const getMetaTag = () => {
    let meta = typeof document !== 'undefined' ? document.querySelector(META_SELECTOR) : null;
    if (!meta && typeof document !== 'undefined') {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'csrf-token');
        document.head.appendChild(meta);
    }

    return meta;
};

export const getXsrfTokenFromCookie = () => {
    if (typeof document === 'undefined') {
        return null;
    }

    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const tokenCookie = cookies.find((cookie) => cookie.startsWith(`${XSRF_COOKIE_NAME}=`));

    if (!tokenCookie) {
        return null;
    }

    try {
        return decodeURIComponent(tokenCookie.split('=')[1]);
    } catch (error) {
        return tokenCookie.split('=')[1];
    }
};

export const getCsrfTokenFromMeta = () => {
    const meta = getMetaTag();

    return meta ? meta.getAttribute('content') : null;
};

export const getCsrfToken = () => getXsrfTokenFromCookie() || getCsrfTokenFromMeta();

export const syncMetaCsrfToken = () => {
    const token = getCsrfToken();
    const meta = getMetaTag();

    if (meta && token) {
        meta.setAttribute('content', token);
    }
};

export const buildCsrfHeaders = () => {
    const xsrfToken = getXsrfTokenFromCookie();
    const csrfToken = getCsrfTokenFromMeta();
    const headers = {};

    if (csrfToken) {
        headers['X-CSRF-TOKEN'] = csrfToken;
    }

    if (xsrfToken) {
        headers['X-XSRF-TOKEN'] = xsrfToken;
        if (!csrfToken) {
            headers['X-CSRF-TOKEN'] = xsrfToken;
        }
    }

    return headers;
};

export const attachCsrfToRequestConfig = (config = {}) => {
    const cfg = { ...config };
    let headers = cfg.headers;

    const applyHeader = (key, value) => {
        if (!value) return;
        if (headers && typeof headers.set === 'function') {
            headers.set(key, value);
        } else {
            if (!headers || typeof headers !== 'object') {
                headers = {};
            }
            headers[key] = value;
        }
    };

    applyHeader('X-Requested-With', 'XMLHttpRequest');

    const csrfHeaders = buildCsrfHeaders();
    Object.entries(csrfHeaders).forEach(([key, value]) => applyHeader(key, value));

    cfg.headers = headers;
    cfg.withCredentials = true;

    return cfg;
};
